import { IShip } from '../../../data/types/ship/ship';
import { CrewMember } from '../../../data/types/crew-member/crew-member';

export const allShipMembers = (ship: IShip): CrewMember[] => {
  return ship.commander ? [...ship.crew, ship.commander] : ship.crew;
};
